import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '../../../../../../utils/rel';
import errorBoundary from '@ifeng/errorBoundary';

class CommentUrl extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        const { title, commentUrl, url, skey } = this.props.docData;
        // console.log(this.props);

        return (
            <li className={styles.message}>
                <a
                    target="_blank"
                    href={`//gentie.ifeng.com/view.html?docName=${title}&docUrl=${commentUrl}&skey=${skey}&pcUrl=${url}`}
                    rel={rel}
                />
            </li>
        );
    }
}

/**
 * 定义组件属性类型
 * */
CommentUrl.propTypes = {
    docData: PropTypes.object,
};

/**
 * 定义组件默认属性
 * */
CommentUrl.defaultProps = {};

export { CommentUrl };
export default errorBoundary(CommentUrl);
